/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Mark_Paid_SuccessInputs */

const vi_tea_purchase_mark_paid_success = /** @type {(inputs: Tea_Purchase_Mark_Paid_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đánh dấu đã thanh toán`)
};

/**

* @param {Tea_Purchase_Mark_Paid_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_mark_paid_success = /** @type {((inputs?: Tea_Purchase_Mark_Paid_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Mark_Paid_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_mark_paid_success(inputs)
});